/** @module logger */
import bole from 'bole';
/**
 * Lightweight wrapper around bole that automatically inserts process.env.CLIENT_ID
 * @example
 * import logger from '@nerdwallet/home-app-lib/logger';
 *
 * logger.error('oh no, its broken'); // error-level log
 * logger.warn('oh no, a warning'); // warn-level log
 * logger.info('some info'); // info-level log
 * logger.debug('some debug stuff'); // debug-level log
 */

export default bole(process.env.CLIENT_ID);